import { render, staticRenderFns } from "./GridAdPlacements.vue?vue&type=template&id=6e51e4a6&"
import script from "./GridAdPlacements.vue?vue&type=script&lang=js&"
export * from "./GridAdPlacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e51e4a6')) {
      api.createRecord('6e51e4a6', component.options)
    } else {
      api.reload('6e51e4a6', component.options)
    }
    module.hot.accept("./GridAdPlacements.vue?vue&type=template&id=6e51e4a6&", function () {
      api.rerender('6e51e4a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AdPlacements/grid/GridAdPlacements.vue"
export default component.exports